/**
 * Fixed Sticky Timeline
 */

(function($) {

    var $stickyTimeline = $('.js-timeline__sticky');

    $stickyTimeline.css('width', $stickyTimeline.parent().width()).fixedsticky();

    $(window).resize(function() {
        $stickyTimeline.css('width', $stickyTimeline.parent().width());
    });

})(jQuery);
